var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"bg-plans-form mt-10"},[_c('h2',[_vm._v(" แผนงานทั้งหมด ")]),_c('table',{ref:"table_plans",staticClass:"display",staticStyle:{"width":"100%"},attrs:{"id":"table_plans"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }